'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var components_flexBox_FlexBox = require('../flexBox/FlexBox.js');
var utilities_combineClasses = require('../../_chunks/combineClasses-5P8GTQkg.js');
require('../../_chunks/InternalFlexBox-BDDWEQ9L.js');
require('../../_chunks/index-CIVOGJRG.js');
require('../../_chunks/designTokens-CKP-YoT2.js');

require("../../_assets/Paper-DtPzhDr8.css");var styles = {"noMargin":"Paper__L204CytFQB__noMargin","paper":"Paper__L204CytFQB__paper","rounded":"Paper__L204CytFQB__rounded","shadow":"Paper__L204CytFQB__shadow"};

const Paper = react.forwardRef(({ children, className, shadow = false, noBorderRadius = false, noMargin = false, ...rest }, ref) => (jsxRuntime.jsx(components_flexBox_FlexBox.FlexBox, { className: utilities_combineClasses.combineClasses(styles.paper, shadow && styles.shadow, !noBorderRadius && styles.rounded, noMargin && styles.noMargin, className), ref: ref, ...rest, children: children })));
Paper.displayName = 'Paper';

exports.Paper = Paper;
//# sourceMappingURL=Paper.js.map
